import $script from 'scriptjs';

import {ANALYTICS_PARAMS, getConfigData} from '@udemy/shared-utils';

import {udMe} from '../lib/global-context/ud-me';

const loadMarketoForms2 = (cb: () => void) => {
    $script('https://info.udemy.com/js/forms2/js/forms2.min.js', () => {
        cb && cb();
    });
};

export const loadClientSideGoogleTagManager = () => {
    const udConfig = getConfigData();
    if (
        udConfig.brand.is_external_sources_enabled &&
        udConfig.brand.is_third_party_marketing_enabled &&
        udConfig.third_party.google_tag_manager_id
    ) {
        // initialize the dataLayer if it doesn't exist, add to the layer if it does
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push({
            isMember: udMe.id > 0,
            env: udConfig.env,
        });
        (async () => {
            window.dataLayer.push(await ANALYTICS_PARAMS.user.extract());
        })();
        window.dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
        const initialScript = document.getElementsByTagName('script')[0];
        const script = document.createElement('script');
        const dl = 'dataLayer' != 'dataLayer' ? `&l=dataLayer` : '';
        script.async = true;

        const tagManagerId = udConfig.third_party.google_tag_manager_id;
        script.src = `//www.googletagmanager.com/gtm.js?id=${tagManagerId}${dl}`;
        if (initialScript && initialScript.parentNode) {
            initialScript.parentNode.insertBefore(script, initialScript);
        }
    }
};

export const marketoLoaders = {
    loadMarketoForms2,
};
